import React, { useRef } from 'react';
import * as Styled from './MButtonIcon.styles';
import { MButtonIconProps, MButtonIconState } from './MButtonIcon.types';
import { AIcon, AIconSize } from '../../atoms/AIcon';
import { useTracking } from '../../hooks';

const COMPONENT_NAME = 'm-web-ui-kit-MButtonIcon';
const TEST_ID = 'web-ui-kit-MButtonIcon';

const MButtonIcon = React.forwardRef<HTMLButtonElement, MButtonIconProps>(
  (
    {
      state = MButtonIconState.Default,
      aIcon,
      trackingProperties,
      custom_click_track_value,
      disabled,
      type = 'button',
      ...rest
    },
    ref
  ) => {
    const defaultRef = useRef<HTMLButtonElement>(null);
    const elementRef = (ref ?? defaultRef) as React.RefObject<HTMLButtonElement>;

    useTracking({
      ref: elementRef,
      trackingProperties,
      custom_click_track_value,
    });

    return (
      <Styled.ButtonIcon
        ref={elementRef}
        data-component-name={COMPONENT_NAME}
        data-testid={TEST_ID}
        $state={state}
        disabled={disabled}
        type={type}
        {...rest}
      >
        <AIcon icon={aIcon?.icon} size={AIconSize.L} />
      </Styled.ButtonIcon>
    );
  }
);

MButtonIcon.displayName = 'MButtonIcon';

export { MButtonIcon, MButtonIconState, TEST_ID as M_BUTTON_ICON_TEST_ID };
export type { MButtonIconProps } from './MButtonIcon.types';
